export const hospitalGuarantorColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'address__address_string',
  'address__addressline1',
  'address__addressline2',
  'address__city',
  'address__postal_code',
  'address__postal_code_extension',
  'address__state',
  'birth_date',
  'gender',
  'guarantor_home_phone',
  'guarantor_mobile_number',
  'guarantor_work_phone',
  'name__first_name',
  'name__last_name',
  'name__middle_name',
  'name__name_prefix',
  'name__name_string',
  'name__name_suffix',
  'phone_number',
  'relationship',
  'snapshot_id',
  'ssn',
];
